<template>
  <router-view key="$router.currentRoute.fullPath" />
</template>

<script>

export default {
  name: "Traceability",
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";

</style>;
